import { observer } from 'mobx-react';
import React from 'react';
import * as S from './PersonaModal.style';

export const PersonaModal = observer(({ persona, onClose, onApply }) => {
	const getImageUrl = (personaKey) => {
		// 페르소나에 맞는 이미지 URL을 반환하는 함수
		const personaName = personaKey.split(' ')[0];

		if (personaName === '리쿠') {
			return [S.basic];
		}
		if (personaName === '소방관') {
			return [S.firefighter];
		}
		if (personaName === '경찰관') {
			return [S.policeman];
		}
		if (personaName === '의사') {
			return [S.doctor];
		}
		if (personaName === '간호사') {
			return [S.nurse];
		}
		if (personaName === '환경지킴이') {
			return [S.environment];
		}
		if (personaName === '천문학자') {
			return [S.astronomer];
		}
		if (personaName === '요리사') {
			return [S.cook];
		}
		if (personaName === '선생님') {
			return [S.teacher];
		}
		return [S.firefighter];
	};

	// 페르소나 역할별 상세 설명 (예시)
	const getPersonaDetails = (personaKey) => {
		const details = {
			'소방관 리쿠': [
				'화재 대피 훈련을 도와주고, 불이 났을 때 지켜야 할 안전 수칙을 알려줍니다.',
			],
			'경찰관 리쿠': ['교통 안전과 공공생활 속에서 지켜야 하는 규칙을 배워요.'],
			'의사 리쿠': ['건강하게 지내는 생활 습관과 병원이 어떤 곳인지 알려줘요.'],
			'간호사 리쿠': ['올바른 손 씻기와 간단한 응급처치 방법을 함께 배워요.'],
			'환경지킴이 리쿠': ['환경보호와 쓰레기 분리수거 방법을 배워요.'],
			'천문학자 리쿠': [
				'별과 우주를 연구하는 천문학자예요. 망원경으로 별을 쳐다보며 연구하고, 우주 지도도 그려봐요. 가끔은 우주에 사는 외계인 친구를 만나는 상상도 한답니다. 오늘은 우주와 별에 관해서 함께 대화하며 연구해 보아요.',
			],
			'요리사 리쿠': [
				'식사할 때 지켜야 할 예절과 몸을 건강하게 해 주는 음식을 소개해요.',
			],
			'선생님 리쿠': [
				'친구와 잘 지내는 방법과 놀이할 때 주의할 점을 이야기해요.',
			],
		};

		return details[personaKey] || [];
	};

	return (
		<S.ModalBackground onClick={onClose}>
			<S.ModalContainer onClick={(e) => e.stopPropagation()}>
				<S.CloseButton onClick={onClose}>&times;</S.CloseButton>

				<S.ModalContent>
					<S.ImageSection>
						<S.PersonaImage src={getImageUrl(persona.key)} alt={persona.key} />
					</S.ImageSection>

					<S.InfoSection>
						<S.Title>{persona.key}</S.Title>
						<S.SubTitle>{persona.desc}</S.SubTitle>

						<S.DetailsList>
							{/* {getPersonaDetails(persona.key).map((detail, index) => (
								<S.DetailItem key={index}>
									<S.DetailIcon>✓</S.DetailIcon>
									<S.DetailText>{detail}</S.DetailText>
								</S.DetailItem>
							))} */}
						</S.DetailsList>

						<S.ApplyButton onClick={() => onApply(persona.key)}>
							적용하기
						</S.ApplyButton>
					</S.InfoSection>
				</S.ModalContent>
			</S.ModalContainer>
		</S.ModalBackground>
	);
});

export default PersonaModal;
